import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ListStateService {

  private state: { [key: string]: { searchQuery: string; firstVisibleRowIndex: number } } = {};

  setListState(serviceAreaId: string, searchQuery: string, firstVisibleRowIndex: number) {
    this.state[serviceAreaId] = { searchQuery, firstVisibleRowIndex: firstVisibleRowIndex };
  }

  getListState(serviceAreaId: string): { searchQuery: string; firstVisibleRowIndex: number } | undefined {
    return this.state[serviceAreaId];
  }

  clearListState(serviceAreaId: string) {
    delete this.state[serviceAreaId];
  }
}
